<template>
    <div 
        class="fixed z-50 bottom-0 ml-24 w-full pointer-events-none" 
        v-if="showIncidentBanner && 
            this.$route.path !== '/login' &&
            this.$route.name !== 'IncidentDetail' &&
            this.$route.name !== 'Incidents' &&
            this.$route.name !== 'Login' &&
            this.$route.name !== 'ResetPassword' &&
            this.$route.name !== 'API404' &&
            this.$route.name !== 'StatisticsNotAvailable' &&
            this.$route.name !== '404'
            "
    >
        <div class="pointer-events-auto w-max max-w-4xl mx-auto flex items-center justify-between gap-x-6 mb-5 rounded-lg bg-yellow-100 p-4 dark:bg-yellow-500/10 dark:outline dark:outline-1 dark:outline-yellow-500/15">
            <router-link to="/incidents" target="_blank" class="flex">
                <div class="shrink-0">
                    <ExclamationCircleIcon class="h-5 w-5 text-yellow-600" aria-hidden="true" />
                </div>
                <div class="flex items-center gap-x-2 ml-3">
                    <div class="text-sm text-yellow-900 dark:text-yellow-100/80">
                        {{ $t('ongoingIncidentDescription', { state: state ? ' ('+state+')' : '' }) }}
                        <span aria-hidden="true">&rarr;</span>
                    </div>
                </div>
            </router-link>

            <button @click="hideIncidentBanner()" type="button" class="-m-1.5 flex-none p-1.5 tooltip">
                <span class="sr-only">{{ $t('dismiss') }}</span>
                <XIcon class="h-5 w-5 text-yellow-600" aria-hidden="true" />
                <p class="text-center text-sm tooltiptext">
                    {{ $t('hideBanner') }}
                </p>
            </button>
        </div>
    </div>
</template>

<script>
import axios from "axios";
import { ExclamationCircleIcon, XIcon } from "@heroicons/vue/outline";

export default {
    name: "IncidentBanner",
    components: {
        ExclamationCircleIcon,
        XIcon,
    },
    data() {
        return {
            showIncidentBanner: false,
            state: null,
        }
    },
    created() {
        this.getIncidents();
    },
    methods: {
        async getIncidents() {
            try {
                const res = await axios.get(`${this.$cookie.getCookie("API")}/api/v1/incidents`);

                if (res.data.length > 0 && res.data.some(incident => incident.resolved_at === null)) {
                    this.displayIncidentBanner();
                    this.state = res.data.find(incident => incident.resolved_at === null)?.state?.name;
                }
            } catch (error) {
                this.errorHandling(error);
            }
        },
        displayIncidentBanner() {
            if (this.$cookie.isCookieAvailable('showIncidentBanner')) {
                this.showIncidentBanner = this.$cookie.getCookie('showIncidentBanner') === 'true';
            } else {
                this.showIncidentBanner = true;
            }
        },
        hideIncidentBanner() {
            this.showIncidentBanner = false;
            this.$cookie.setCookie('showIncidentBanner', this.showIncidentBanner, {
                expire: '1d',
            });
        }
    }
}
</script>

<style scoped>
.tooltip {
    position: relative;
    display: inline-block;
}

.tooltip .tooltiptext {
    visibility: hidden;
    width: 150px;
    background-color: #111827;
    color: #fff;
    text-align: center;
    border-radius: 6px;
    padding: 5px;
    position: absolute;
    z-index: 1;
    bottom: 120%;
    left: 100%;
    margin-left: -92px;
}

.tooltip .tooltiptext::after {
    content: "";
    position: absolute;
    top: 100%;
    left: 50%;
    margin-left: -5px;
    border-width: 5px;
    border-style: solid;
    border-color: #111827 transparent transparent transparent;
}

.tooltip:hover .tooltiptext {
    visibility: visible;
}
</style>